import {
  FETCH_PLANS_REQUEST,
  FETCH_PLANS_SUCCESS,
  FETCH_PLANS_FAILURE,
  CREATE_PLAN_REQUEST,
  CREATE_PLAN_SUCCESS,
  CREATE_PLAN_FAILURE,
  UPDATE_PLAN_REQUEST,
  UPDATE_PLAN_SUCCESS,
  UPDATE_PLAN_FAILURE,
  DELETE_PLAN_REQUEST,
  DELETE_PLAN_SUCCESS,
  DELETE_PLAN_FAILURE,
} from "./types";

import { fetchPlans, createPlan, updatePlan, deletePlan } from "../../services/plansServices";

// Fetch Plans
export const fetchPlansAction = () => async (dispatch) => {
  dispatch({ type: FETCH_PLANS_REQUEST });
  try {
    const response = await fetchPlans();
    if (response.success) {
      // Use the actual data array
      dispatch({ type: FETCH_PLANS_SUCCESS, payload: response.data.data });
    } else {
      dispatch({ type: FETCH_PLANS_FAILURE, payload: response.error || response.data?.message });
    }
  } catch (error) {
    dispatch({ type: FETCH_PLANS_FAILURE, payload: error.message || "Failed to fetch plans" });
  }
};

// Create Plan
export const createPlanAction = (payload) => async (dispatch) => {
  dispatch({ type: CREATE_PLAN_REQUEST });
  try {
    const response = await createPlan(payload);
    if (response.success) {
      dispatch({ type: CREATE_PLAN_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: CREATE_PLAN_FAILURE, payload: response.error || response.data?.message });
    }
  } catch (error) {
    dispatch({ type: CREATE_PLAN_FAILURE, payload: error.message || "Failed to create plan" });
  }
};

// Update Plan
export const updatePlanAction = (id, payload) => async (dispatch) => {
  dispatch({ type: UPDATE_PLAN_REQUEST });
  try {
    const response = await updatePlan(id, payload);
    if (response.success) {
      dispatch({ type: UPDATE_PLAN_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: UPDATE_PLAN_FAILURE, payload: response.error || response.data?.message });
    }
  } catch (error) {
    dispatch({ type: UPDATE_PLAN_FAILURE, payload: error.message || "Failed to update plan" });
  }
};

// Delete Plan
export const deletePlanAction = (id) => async (dispatch) => {
  dispatch({ type: DELETE_PLAN_REQUEST });
  try {
    const response = await deletePlan(id);
    if (response.success) {
      dispatch({ type: DELETE_PLAN_SUCCESS, payload: id });
    } else {
      dispatch({ type: DELETE_PLAN_FAILURE, payload: response.error || response.data?.message });
    }
  } catch (error) {
    dispatch({ type: DELETE_PLAN_FAILURE, payload: error.message || "Failed to delete plan" });
  }
};
